import api from '@/assets/js/api.js'

const state = {
  cart: null,
  carriers: [],
  order: null,
  cartJustTransformedToOrder: false
}
const getters = {
  checkout_get_cart: state => {
    return state.cart
  },
  checkout_get_order: state => {
    return state.order
  },
  checkout_get_address: state => {
    return state.cart && state.cart.shipping_address ? state.cart.shipping_address : {}
  },
  checkout_get_invoice_address: state => {
    return state.cart && state.cart.billing_address ? state.cart.billing_address : {}
  },
  checkout_get_paymentMethod: state => {
    return state.cart && state.cart.paymentDetails ? state.cart.paymentDetails : {}
  },
  checkout_get_carrier: state => {
    return state.cart && state.cart.carrier ? state.cart.carrier : {}
  },
  checkout_get_carriers: state => {
    return state.cart ? state.carriers : {}
  },
  checkout_get_order_address: state => {
    return state.order ? state.order.shipping_address : {}
  },
  checkout_get_order_invoice_address: state => {
    return state.order ? state.order.billing_address : {}
  },
  checkout_get_order_paymentMethod: state => {
    return state.order ? state.order.paymentDetail : {}
  },
  checkout_get_order_carrier: state => {
    return state.order ? state.order.carrier : {}
  },
  checkout_cart_just_into_order: state => {
    return state.cartJustTransformedToOrder
  }
}

const mutations = {
  CHECKOUT_SET_CART (state, cart) {
    state.cart = cart
  },
  CHECKOUT_SET_ORDER (state, order) {
    state.order = order
  },
  CHECKOUT_SET_CARRIER_LIST (state, list) {
    state.carriers = list
  },
  CHECKOUT_RESET (state) {
    state.cart = null
  },
  CHECKOUT_SET_CART_JUST_INTO_ORDER (state, value) {
    state.cartJustTransformedToOrder = value
  }
}

const actions = {
  getCarriers ({commit, rootGetters}, shopUid) {
    if (!rootGetters.global_is_busy_method('getCarriers')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getCarriers')
      api.getCarriers(shopUid, 1000).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getCarriers')
          console.log(response.data)
          commit('CHECKOUT_SET_CARRIER_LIST', response.data)
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getCarriers')
          console.log(error)
        }
      )
    }
  },
  getCheckoutCart ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('getCheckoutCart')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getCheckoutCart')
      api.getCart(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getCheckoutCart')
          console.log(response.data)
          commit('CHECKOUT_SET_CART', response.data)
          if (payload.cb) {
            payload.cb()
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getCheckoutCart')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  },
  checkoutCart ({ commit, dispatch, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('checkoutCart')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'checkoutCart')
      api.cartToOrder(payload.cart).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'checkoutCart')
          console.log(response.data)
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'checkoutCart')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  updateCartAddress ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('updateCartAddress')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'updateCartAddress')
      api.updateCartAddress(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'updateCartAddress')
          commit('CHECKOUT_SET_CART', response.data)
          if (payload.cb) {
            payload.cb()
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'updateCartAddress')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  updateCartInvoiceAddress ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('updateCartInvoiceAddress')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'updateCartInvoiceAddress')
      api.updateCartAddress(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'updateCartInvoiceAddress')
          commit('CHECKOUT_SET_CART', response.data)
          if (payload.cb) {
            payload.cb()
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'updateCartInvoiceAddress')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  updateCartPayment ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('updateCartPayment')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'updateCartPayment')
      api.updateCartPayment(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'updateCartPayment')
          commit('CHECKOUT_SET_CART', response.data)
          if (payload.cb) {
            payload.cb()
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'updateCartPayment')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  updateCarrier ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('updateCarrier')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'updateCarrier')
      api.updateCarrier(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'updateCarrier')
          commit('CHECKOUT_SET_CART', response.data)
          if (payload.cb) {
            payload.cb()
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'updateCarrier')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  downloadInvoiceAction ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('downloadInvoiceAction')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'downloadInvoiceAction')
      api.getInvoicePDF(payload.order).then(
        response => {
          if (payload.cb) {
            payload.cb(response)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'downloadInvoiceAction')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  getOrder ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('getOrder')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getOrder')
      api.getOrder(payload.order).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getOrder')
          commit('CHECKOUT_SET_ORDER', response.data)
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getOrder')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/checkout.js